// frontend/src/store/slices/userSlice.ts

import { create } from 'zustand'

interface UserState {
  profile: any | null
  resumes: any[]
  applications: any[]
  isLoading: boolean

  // Actions
  setProfile: (profile: any) => void
  setResumes: (resumes: any[]) => void
  setApplications: (applications: any[]) => void
  setLoading: (isLoading: boolean) => void
  clearProfile: () => void
}

export const useUserStore = create<UserState>((set) => ({
  profile: null,
  resumes: [],
  applications: [],
  isLoading: false,

  setProfile: (profile) => set({ profile }),
  setResumes: (resumes) => set({ resumes }),
  setApplications: (applications) => set({ applications }),
  setLoading: (isLoading) => set({ isLoading }),
  clearProfile: () => set({ profile: null, resumes: [], applications: [] })
}))